import React from "react";
import Particles from "react-particles-js";

export default function Particle() {
  return (
    <div
      style={{
        zIndex: -1,
        position: "absolute",
        top: 0,
        left: 0,
        // width: "100%",
        // height: "100%",
      }}
    >
      <Particles
        style={{
          width: "100%",
          height: "100%",
          position: " fixed",
          // backgroundColor: "#000",
          // backgroundImage: "url('')",
          backgroundSize: "cover",
          backgroundPosition: " 50% 50%",
          backgroundRepeat: "no-repeat",
        }}
        params={{
          particles: {
            number: {
              value: 40,
              density: {
                enable: true,
                value_area: 800,
              },
            },
            color: {
              value: "#ffd66b",
            },
            background: {
              color: {
                value: "#1d1d1d",
              },
            },
            collisions: {
              enable: true,
            },
            shape: {
              type: "circle",
            },
            size: {
              value: 4.5,
              random: true,
            },
            line_linked: {
              enable: true,
              distance: 200,
              color: "#ffd66b",
              opacity: 0.5,
              width: 1,
            },
            move: {
              enable: true,
              speed: 4,
              direction: "none",
              random: false,
              straight: false,
              out_mode: "bounce",
            },
          },
          fpsLimit: 60,
          interactivity: {
            detect_on: "canvas",
            events: {
              onhover: {
                enable: true,
                mode: "repulse",
              },
              onclick: {
                enable: true,
                mode: "push",
              },
              resize: true,
            },
            modes: {
              bubble: {
                distance: 400,
                size: 40,
                duration: 2,
                opacity: 0.8,
              },
              repulse: {
                distance: 200,
                duration: 0.4,
              },
              push: {
                particles_nb: 4,
              },
            },
          },
          retina_detect: true,
        }}
      />
    </div>
  );
}
